import Spinner from 'react-bootstrap/Spinner';

interface SpinnerProps {
    className? : string,
    show? : boolean
}

export const AccessibleSpinner = ({show, className} : SpinnerProps) =>
{
    return show ? (
        <Spinner className={className} size="sm" animation="border" variant="primary">
            <span className="visually-hidden">Loading...</span>
        </Spinner>
    ) : null;
}
